import PropTypes from "prop-types";
import React from "react";
import { Eyebrow, Image } from "../../../../elements";
import getClassNameFactory from "../../../../utilities/classNames";

var ChapterDivider = function ChapterDivider(_ref) {
  var backgroundAnchor = _ref.backgroundAnchor,
      backgroundGradient = _ref.backgroundGradient,
      backgroundSrc = _ref.backgroundSrc,
      backgroundSrcSet = _ref.backgroundSrcSet,
      chapterText = _ref.chapterText,
      colorTheme = _ref.colorTheme,
      id = _ref.id,
      titleText = _ref.titleText;
  var getClassName = getClassNameFactory("LongformChapterDivider");
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: colorTheme
    }),
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "background"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "backgroundImage"
    })
  }, backgroundSrc ? /*#__PURE__*/React.createElement(Image, {
    alt: "",
    anchor: backgroundAnchor,
    fit: "cover",
    sizes: Image.sizes.edgeToEdge,
    src: backgroundSrc,
    srcSet: backgroundSrcSet
  }) : null)), backgroundSrc && backgroundGradient ? /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "background"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "backgroundGradient"
    })
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "content"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "inner"
    })
  }, chapterText && /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "chapter",
      utilities: "textAntialiased"
    })
  }, /*#__PURE__*/React.createElement(Eyebrow, {
    text: chapterText
  })), /*#__PURE__*/React.createElement("h2", {
    className: getClassName({
      descendantName: "title"
    })
  }, titleText))));
};
/* eslint-disable max-len */


ChapterDivider.propTypes = {
  /**
   * Anchor point for the background image.
   */
  backgroundAnchor: PropTypes.oneOf(Object.values(Image.AnchorTypes)),

  /**
   * A backgroundGradient to apply over the background image. Should not be used if the image has a rasterized backgroundGradient.
   */
  backgroundGradient: PropTypes.bool,

  /**
   * Background image `src`. Used if srcSet is not defined, or as a fallback.
   */
  backgroundSrc: PropTypes.string,

  /**
   * A comma-separated list indicating a set of possible image sources for the background. The image will be fit to cover. This is used by the user agent to determine the correct image for different screen sizes. Same format as [srcSet](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#Example_4_Using_the_srcset_and_sizes_attributes), i.e. `my-image-200.png 200w, my-image-200.png 200w`.
   */
  backgroundSrcSet: PropTypes.string,

  /**
   * Used for the chapter text of this section
   */
  chapterText: PropTypes.string,

  /**
   * Color theme. This is the color of the text, not the asset.
   */
  colorTheme: PropTypes.oneOf(["dark", "light"]),

  /**
   * ID for the element. Use with ChapterNav.
   */
  id: PropTypes.string,

  /**
   * Used for the title of this section
   */
  titleText: PropTypes.string.isRequired
};
/* eslint-enable max-len */

ChapterDivider.defaultProps = {
  backgroundAnchor: "C",
  backgroundGradient: true,
  colorTheme: "light"
};
ChapterDivider.displayName = "Longform.ChapterDivider";
export default ChapterDivider;